module.exports = __webpack_public_path__ + "media/brands/nissan-e84c868a.png";